export default __webpack_public_path__ + "static/media/omnisearch.54594336.md";